import {StorageManager} from "@features/storage-manager/storage-manager";

export const debugLog = (...data: any[]) => {
    if (process.env.NODE_ENV === 'development') {
        console.log(...data)
    }
    if (StorageManager.getFromLocal('debug', false)) console.log(...data)
}